import { graphql } from '~/graphql/generated/gql';

export const UNIFIED_PUT_ONBOARDING_ENTITY = graphql(`
  mutation unifiedPutOnboardingEntity($input: SelectedEntityInput!) {
    unifiedPutOnboardingEntity(input: $input)
  }
`);

export const UNIFIED_RESET_ALL = graphql(`
  mutation unifiedResetAll {
    unifiedResetAll {
      id
      unifiedOnboardingComplete
    }
  }
`);

export const UNIFIED_DEV_AWARD_COINS = graphql(`
  mutation unifiedDevAwardCoins {
    unifiedDevAwardCoins
  }
`);

export const UNIFIED_DEV_COMPLETE_COLLECTION = graphql(`
  mutation unifiedDevCompleteCollection($collectionSlug: String!) {
    unifiedDevCompleteCollection(collectionSlug: $collectionSlug) {
      completedAssetNames
      remainingCount
      collectionCompleted
    }
  }
`);

export const UNIFIED_DEV_COMPLETE_NEXT_ASSET = graphql(`
  mutation unifiedDevCompleteNextAsset($collectionSlug: String!) {
    unifiedDevCompleteNextAsset(collectionSlug: $collectionSlug) {
      completedAssetNames
      remainingCount
      collectionCompleted
    }
  }
`);

export const UNIFIED_DEV_TOGGLE_PHONE_VERIFICATION = graphql(`
  mutation unifiedDevTogglePhoneVerification {
    unifiedDevTogglePhoneVerification {
      id
      studentRoles {
        ...StudentRoleFields
      }
    }
  }
`);

export const UNIFIED_DEV_CLEAR_USER_PROGRESS = graphql(`
  mutation unifiedDevClearUserProgress {
    unifiedDevClearUserProgress
  }
`);

export const UNIFIED_DEV_SET_ONBOARDING_EXPLORE_CAREER = graphql(`
  mutation unifiedDevSetOnboardingExploreCareer($occupationId: String) {
    unifiedDevSetOnboardingExploreCareer(occupationId: $occupationId)
  }
`);

export const UNIFIED_DEV_SET_ONBOARDING_EXPLORE_INDUSTRY = graphql(`
  mutation unifiedDevSetOnboardingExploreIndustry($industryId: ID) {
    unifiedDevSetOnboardingExploreIndustry(industryId: $industryId)
  }
`);

export const UNIFIED_DEV_SET_ONBOARDING_EXPLORE_CONTENT = graphql(`
  mutation unifiedDevSetOnboardingExploreContent($collectionId: ID) {
    unifiedDevSetOnboardingExploreContent(collectionId: $collectionId)
  }
`);

export const UNIFIED_DEV_SET_ONBOARDING_UTM_CAMPAIGN = graphql(`
  mutation unifiedDevSetOnboardingUtmCampaign($utmKey: String) {
    unifiedDevSetOnboardingUtmCampaign(utmKey: $utmKey)
  }
`);

export const UNIFIED_DEV_LANE_SEED_CANDIDATES = graphql(`
  query unifiedDevLaneSeedCandidates {
    unifiedDevLaneSeedCandidates {
      occupations {
        id
        name
      }
      industries {
        id
        name
      }
      collections {
        id
        name
      }
      utmKeys
    }
  }
`);

export const UNIFIED_ONBOARDING_BLINKY_MESSAGE = graphql(`
  query unifiedOnboardingBlinkyMessage($selectedEntity: SelectedEntityInput, $utmKey: String) {
    unifiedOnboardingBlinkyMessage(selectedEntity: $selectedEntity, utmKey: $utmKey) {
      message
      exitMessage
    }
  }
`);

export const UTM_OVERRIDES = graphql(`
  query utmOverrides($page: Int, $first: Int) {
    utmOverrides(page: $page, first: $first) {
      data {
        id
        utmKey
        onboardingBlinkyMessage
        exitBlinkyMessage
      }
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
    }
  }
`);

export const UPSERT_UTM_OVERRIDE = graphql(`
  mutation upsertUtmOverride($input: UpsertUtmOverrideInput!) {
    upsertUtmOverride(input: $input) {
      id
      utmKey
      onboardingBlinkyMessage
      exitBlinkyMessage
    }
  }
`);

export const DELETE_UTM_OVERRIDE = graphql(`
  mutation deleteUtmOverride($input: DeleteUtmOverrideInput!) {
    deleteUtmOverride(input: $input) {
      id
    }
  }
`);
